import Vue from "vue";
import { API_ROOT, studies, studyManagement, resource, createresource, sitesUrl, user, getallresource } from "./urls";

const clientId = window.localStorage.getItem("thread-clientId");
const addResourcesData = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}{/studyId}/${createresource}`,
  {},
  {
    save: {
      method: "POST"
    }
  }
);

const getPIsitesData = Vue.resource(
  `${API_ROOT}${studyManagement}${studies}/{studyId}/${user}{/userId}/${sitesUrl}`,
  {},
  {
    save: {
      method: "GET"
    }
  }
);

const getsites = Vue.resource(
  `${API_ROOT}${studyManagement}/${studies}{/studyId}${sitesUrl}`,
  {},
  {
    get: {
      method: "GET"
    }
  }
);

const getAllResources = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}{/studyId}/${getallresource}?type={resourceType}`,
  {},
  {
    get: {
      method: "GET"
    }
  }
);

const getResourceAnnouncementsCount = Vue.resource(
  `${API_ROOT}${studyManagement}user{/userId}/zendesk`,
  {},
  {
    get: {
      method: "GET"
    }
  }
);

const postResourceAnnouncements = Vue.resource(
  `${API_ROOT}${studyManagement}user{/userId}/zendesk`,
  {},
  {
    save: {
      method: "POST"
    }
  }
);

const getZendeskRedirectPayloadData = Vue.resource(
  `${API_ROOT}${studyManagement}user{/userId}/zendesk/sso/payload?name={name}&email={email}`,
  {},
  {
    get: {
      method: "GET"
    }
  }
);

const getOneResource = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}/getoneresource?id={resourceId}`,
  {},
  {
    get: {
      method: "GET"
    }
  }
);

const deleteResource = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}/deleteresource?id={resourceId}&active=false`,
  {},
  {
    delete: {
      method: "DELETE"
    }
  }
);

const deactivateResource = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}/changeresourcestatus?id={resourceId}&status=false`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const reactivateResource = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}/changeresourcestatus?id={resourceId}&status=true`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const editResourceData = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}/editresource?id={resourceId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getMaterialFileUrl = Vue.resource(
  `${API_ROOT}${studyManagement}${resource}/${studies}/getpresignedurl`,
  {},
  {
    save: {
      method: "POST"
    }
  }
);

export function getSitesData(studyId) {
  return getsites.get({ studyId }, { headers: { clientId: clientId } });
}

export function addResourcesCreation(studyId, data) {
  return addResourcesData.save(
    {
      studyId
    },
    data
  );
}

export function getAllResourcesData(studyId, resourceType) {
  return getAllResources.get({ studyId, resourceType }, { headers: { clientId: clientId } });
}

export function getResourceAnnouncementsCountData(userId) {
  return getResourceAnnouncementsCount.get({ userId });
}

export function postResourceAnnouncementsData(userId) {
  return postResourceAnnouncements.save({ userId }, {});
}

export function zendeskRedirectPayloadData(queryParams) {
  return getZendeskRedirectPayloadData.get(queryParams, {
    headers: { clientId: clientId }
  });
}

export function getOneResourceData(resourceId) {
  return getOneResource.get({ resourceId }, { headers: { clientId: clientId } });
}

export function deleteResourceData(resourceId) {
  return deleteResource.delete({ resourceId }, { headers: { clientId: clientId } });
}

export function deactivateResourceData(resourceId) {
  return deactivateResource.update({ resourceId }, { headers: { clientId: clientId } });
}

export function getPIDetails(studyId, userId) {
  return getPIsitesData.get({ studyId, userId });
}

export function reactivateResourceData(resourceId) {
  return reactivateResource.update({ resourceId }, { headers: { clientId: clientId } });
}

export function editResource(resourceId, data) {
  return editResourceData.update({ resourceId }, data);
}

export function getPresignedURL(data) {
  return getMaterialFileUrl.save(data);
}
